module.exports = __webpack_public_path__ + "img/footer.5c3fbf2a.png";